import { MoreOutlined } from "@ant-design/icons";
import { Button, Dropdown, MenuProps } from "antd";
import { useMemo } from "react";
import { useRole } from "../../../../../features/roles/useRole";

type Props = {
  itemId: number;
  goToDetails: (id: number) => void;
  onModify: (id: number) => void;
  onDelete: (id: number) => void;
};

const DropdownOptionsConstat: React.FC<Props> = ({
  itemId,
  goToDetails,
  onModify,
  onDelete,
}) => {
  const { isAdmin } = useRole();

  const items = useMemo(() => {
    const _items: MenuProps["items"] = [
      {
        key: "view",
        label: (
          <a onClick={(e) => { e.stopPropagation(); goToDetails(itemId); }}>
            Voir le constat
          </a>
        ),
      },
    ];

    if (isAdmin) {
      _items.push({
        key: "modify",
        label: (
          <a onClick={(e) => { e.stopPropagation(); onModify(itemId); }}>
            Modifier le constat
          </a>
        ),
      });
      _items.push({
        key: "delete",
        danger: true,
        label: (
          <a onClick={(e) => { e.stopPropagation(); onDelete(itemId); }}>
            Supprimer
          </a>
        ),
      });
    }

    return _items;
  }, [itemId, isAdmin, goToDetails, onModify, onDelete]);

  return (
    <Dropdown menu={{ items }} trigger={["click"]}>
      <Button
        type="link"
        icon={<MoreOutlined />}
        onClick={(e) => e.stopPropagation()}
      />
    </Dropdown>
  );
};

export default DropdownOptionsConstat;
